import { Line } from "@react-three/drei";
import { Box } from "@react-three/flex";
import GeoFlex from "../Flexes/GeoFlex";
import ImgFlex from "../Flexes/ImgFlex";
import TxtFlex from "../Flexes/TxtFlex";

function ZoolanderBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
  txtOne
}) {

  return(
    <>
    <Box
      flexDirection='column' 
      align={align} 
      justify='space-evenly'
      width='100%'
      // height='60%'
      // wrap='wrap'
      margin={scale}
      flexGrow={scale}
    >
      <Box
        marginBottom={7 * scale}
        marginleft={scale}
      >
        <ImgFlex
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          image='/pictures/ZL_SS.PNG'
          viewport={viewport}
          txtOne={txtOne}
          // txtTwo={'Designer\n Musician\n'}
          txtColorOne='#249D9F'
          txtColorTwo='gold'
          textScaleFactor={1.025 * scale}
          textAlign='left'
        />
      </Box>
      <Box
        // margin={scale}
        marginLeft={5 * scale}
        // padding={scale}
      >
        <TxtFlex 
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          txtColorOne='white'
          txtColorTwo='white'
          textScaleFactor={scale * 0.45}
          textAlign='left'
          text={
            `
            zooLander is an educational application.\n 
            It allows users to build their own personal zoo.\n
            Collaborative planning process to determine MVP.\n 
            Heavy contributions for UX/UI.\n
            Implemented authorization for users.\n 
            JSON dictionary and API managment.\n



            5 day sprint, 4 developers.`
        }
          />
        </Box>
    </Box>    
    </>
  );
};

export default ZoolanderBox;